'use client'

import { Builder } from '@builder.io/react'

import { Carousel } from './Carousel'

Builder.registerComponent(Carousel, {
  name: 'Carousel',
  noWrap: true,
  inputs: [
    {
      name: 'overflowDesktop',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'overflowMobile',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'slides',
      type: 'list',
      subFields: [
        {
          name: 'blocks',
          hideFromUI: true,
          type: 'array',
        },
      ],
      defaultValue: [
        {
          blocks: [],
        },
        {
          blocks: [],
        },
        {
          blocks: [],
        },
      ],
    },
    {
      name: 'showDots',
      friendlyName: 'Show Dots on Desktop',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'showDotsOnMobile',
      friendlyName: 'Show Dots on Mobile',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'dotsStyle',
      type: 'object',
      subFields: [
        {
          name: 'position',
          type: 'text',
          defaultValue: 'Outside Slider',
          enum: ['Inside Slider', 'Outside Slider'],
        },
        {
          name: 'selectedColor',
          type: 'color',
          defaultValue: '#bcf985',
        },
        {
          name: 'deselectedColor',
          type: 'color',
          defaultValue: '#393b3b',
        },
      ],

      defaultValue: {
        position: 'Outside Slider',
        selectedColor: '#bcf985',
        deselectedColor: '#393b3b',
      },
    },
    {
      name: 'slidesPerView',
      friendlyName: 'Number of slides on the screen',
      type: 'number',
      defaultValue: 3,
    },
    {
      name: 'slideSpacing',
      friendlyName: 'Spacing between slides',
      type: 'number',
      defaultValue: 40,
    },
    {
      name: 'numberOfSlidesMoving',
      type: 'number',
      defaultValue: 1,
    },
    {
      name: 'autoSlide',
      friendlyName: 'Auto Play',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'animationDuration',
      friendlyName: 'Animation Duration(ms)',
      type: 'number',
      defaultValue: 1000,
    },
    {
      name: 'autoSlideInterval',
      friendlyName: 'Interval between each slide when auto playing',
      type: 'number',
      defaultValue: 2000,
    },
    {
      name: 'showArrows',
      friendlyName: 'Show Arrows (Desktop)',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'arrowVerticalPosition',
      friendlyName: 'Vertical Arrow Position',
      type: 'text',
      defaultValue: 'image',
      enum: ['image', 'slide'],
    },
    {
      name: 'arrowColor',
      friendlyName: 'Arrow Background Color',
      type: 'color',
    },
    {
      name: 'arrowIconColor',
      friendlyName: 'Arrow Color',
      type: 'color',
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/carousel-horizontal.svg',
})
